import { filtersApi } from '@listen360/js_api_client'
import { reduce } from 'lodash'

import {
  GET_FILTERS_PENDING,
  GET_FILTERS_ERROR,
  GET_FILTERS_SUCCESS,
  SET_APPLIED_DATE_RANGE,
  CLEAR_APPLIED_DATE_RANGE,
  TOGGLE_FILTER_CATEGORY,
  CLEAR_OPEN_FILTER_CATEGORIES,
  UPDATE_CATEGORY_FILTERS,
  CLEAR_CATEGORY_FILTERS,
  CLEAR_ALL_CATEGORY_FILTERS
} from '../constants'

export const namespaced = true

export const state = {
  isLoadingFilters: false,
  loadingFiltersError: null,
  filterCategories: [],
  appliedDateRange: [],
  filterCategoriesOpen: {},
  appliedFilters: {}
}

export const actions = {
  getFilters({ commit }) {
    commit(GET_FILTERS_PENDING)

    return filtersApi
      .get()
      .then(data => {
        commit(GET_FILTERS_SUCCESS, data)
      })
      .catch(error => {
        commit(GET_FILTERS_ERROR, error)
      })
  },
  setAppliedDateRange({ commit }, dates) {
    commit(SET_APPLIED_DATE_RANGE, dates)
  },
  clearAppliedDateRange({ commit }) {
    commit(CLEAR_APPLIED_DATE_RANGE)
  },
  toggleFilterCategory({ commit }, categoryId) {
    commit(TOGGLE_FILTER_CATEGORY, categoryId)
  },
  updateCategoryFilters({ commit }, { categoryId, filters }) {
    commit(UPDATE_CATEGORY_FILTERS, { categoryId, filters })
  },
  clearCategoryFilters({ commit }, categoryId) {
    commit(CLEAR_CATEGORY_FILTERS, categoryId)
  },
  clearAllCategoryFilters({ commit }) {
    commit(CLEAR_ALL_CATEGORY_FILTERS)
  },
  clearOpenFilterCategories({ commit }) {
    commit(CLEAR_OPEN_FILTER_CATEGORIES)
  }
}

export const mutations = {
  [GET_FILTERS_PENDING]: state => {
    state.isLoadingFilters = true
    state.loadingFiltersError = null
  },
  [GET_FILTERS_ERROR]: (state, error) => {
    state.isLoadingFilters = false
    state.loadingFiltersError = error
  },
  [GET_FILTERS_SUCCESS]: (state, filters) => {
    state.isLoadingFilters = false
    state.filterCategories = filters.map(filter => ({
      ...filter,
      choices: filter.choices.sort((a, b) => {
        var x = a.name.toLowerCase()
        var y = b.name.toLowerCase()

        if (x < y) return -1
        if (x > y) return 1

        return 0
      })
    }))
  },
  [SET_APPLIED_DATE_RANGE]: (state, dates) => {
    state.appliedDateRange = dates
  },
  [CLEAR_APPLIED_DATE_RANGE]: state => {
    state.appliedDateRange = []
  },
  [TOGGLE_FILTER_CATEGORY]: (state, categoryId) => {
    const newCategoriesOpen = { ...state.filterCategoriesOpen }

    if (newCategoriesOpen[categoryId]) {
      delete newCategoriesOpen[categoryId]
    } else {
      newCategoriesOpen[categoryId] = true
    }

    state.filterCategoriesOpen = newCategoriesOpen
  },
  [UPDATE_CATEGORY_FILTERS]: (state, { categoryId, filters }) => {
    state.appliedFilters = {
      ...state.appliedFilters,
      [categoryId]: {
        ...filters
      }
    }
  },
  [CLEAR_CATEGORY_FILTERS]: (state, categoryId) => {
    const newAppliedFilters = {
      ...state.appliedFilters
    }

    delete newAppliedFilters[categoryId]

    state.appliedFilters = newAppliedFilters
  },
  [CLEAR_ALL_CATEGORY_FILTERS]: state => {
    state.appliedFilters = {}
  },
  [CLEAR_OPEN_FILTER_CATEGORIES]: state => {
    state.filterCategoriesOpen = {}
  }
}

export const getters = {
  errorLoadingFilters: state => Boolean(state.loadingFiltersError),
  filterCategories: state => state.filterCategories,
  isLoadingFilters: state => state.isLoadingFilters,
  appliedDateRange: state => state.appliedDateRange,
  appliedFilters: state => state.appliedFilters,
  filterCategoriesOpen: state => state.filterCategoriesOpen,
  tags: state => {
    return reduce(
      state.appliedFilters,
      (previous, current) => {
        let tags = reduce(
          current,
          (prev, curr) => {
            return prev.concat([curr])
          },
          []
        )

        return previous.concat(tags)
      },
      []
    )
  }
}
